import React from 'react';
import PropTypes from 'prop-types';

import { SVGIcon } from 'common/components';
import { useClassName } from 'common/hooks';

import './collapsible-info-item.less';

const CollapsibleInfoItem = ({ title, visible, onToggle, children }) => {
  const classNames = useClassName('CollapsibleInfoItem');

  return (
    <div className={classNames(['container', visible && 'visible'])}>
      <div onClick={onToggle} className={classNames('header')}>
        <h4>{title}</h4>
        <SVGIcon name="angle-down" size="mini" />
      </div>
      {visible && <div className={classNames('content')}>{children}</div>}
    </div>
  );
};

CollapsibleInfoItem.propTypes = {
  title: PropTypes.node,
  visible: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.node,
};

export default CollapsibleInfoItem;
